import { Injectable } from '@angular/core';
import { LocalService } from './local.service';
import { SessionService } from './session.service';
@Injectable({
  providedIn: 'root'
})
export class StorageService {
  constructor(private sessionService: SessionService, private localService: LocalService) { }
  // -------------- SESSION STORAGE ---------------------
  setJsonValueSession(key: string, value: any) {
    this.sessionService.secureStorage.setItem(key, value);
  }
  getJsonValueSession(key: string) {
    return this.sessionService.secureStorage.getItem(key);
  }
  clearSession() {
    this.sessionService.secureStorage.clear();
  }
  removeSession(key: string)
  {
    this.sessionService.secureStorage.removeItem(key);
  }
  // ---------------- LOCAL STORAGE --------------------
  setJsonValueLocal(key: string, value: any) {
    this.localService.secureStorage.setItem(key, value);
  }
  getJsonValueLocal(key: string) {
    return this.localService.secureStorage.getItem(key);
  }
  clearLocal() {
    return this.localService.secureStorage.clear();
  }
  removeLocal(key: string)
  {
    this.localService.secureStorage.removeItem(key);
  }
}
